import { render, staticRenderFns } from "./AlertStatus.vue?vue&type=template&id=5bd80050&scoped=true&"
import script from "./AlertStatus.vue?vue&type=script&lang=js&"
export * from "./AlertStatus.vue?vue&type=script&lang=js&"
import style0 from "./AlertStatus.vue?vue&type=style&index=0&id=5bd80050&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd80050",
  null
  
)

export default component.exports